export default __webpack_public_path__ + "static/media/Corpus Sandals.65f1466f.jpg";